import { useEffect as c } from "react";
import t from "../../../node_modules/js-cookie/dist/js.cookie.mjs";
const i = ({
  pagePath: o,
  handlerError: s
}) => {
  const e = "error_message", r = t.get(e);
  c(() => {
    r && (s(r), t.remove(e, {
      path: o
    }));
  }, [r, o]);
};
export {
  i as useCatchCookiePurchaseError
};
